import {useState} from "react";
import styles from "./switch.module.css";

type SwitchProps = {
    style?: React.CSSProperties;
    checked?: boolean;
    onchange?: (value: boolean) => void | Promise<void>;
}

const Switch: React.FC<SwitchProps> = (props) => {
    const {
        style,
        onchange,
    } = props;

    const [checked, setChecked] = useState(props.checked);

    async function onClick() {
        const nextChecked = !checked;
        setChecked(nextChecked);
    }

    return (
        <div
            style={style}
            onClick={onClick}
            className={`${styles.switch} ${checked ? styles.switch_checked : ''}`}
            role="switch"
            aria-checked={checked}
        >
            <div className={`${styles.checkbox}`}>
                <div className={`${styles.handle}`}></div>
            </div>
        </div>
    )
}

export default Switch;